<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :queryParams="queryParams"
      :enableSearch="false"
      :requestPromise="loadPromise"
      :columns="getColumns()"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除当前绑定？" @confirm="unbind(rowItem.record)">
          <a>删除绑定</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" width="750px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentLayout.labelCol"
                    :wrapper-col="currentLayout.wrapperCol">
        <a-form-model-item label="所属供应商" prop="id">
          <a-select v-model="ruleForm.id" @change='handleChange' placeholder="请选择" style='max-width: 370px;'>
            <a-select-option v-for="item in supplierList" :value="item.id" :key="item.id">{{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" prop="proId">
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span v-if="ruleForm.proId" style="margin-left: 3px;">商品ID:{{ ruleForm.proId }}</span>
          <span style="margin-left: 3px;">&nbsp;*仅能关联门票类型且未上架的自有产品</span>
        </a-form-model-item>
        <a-form-model-item label="供应商门票名称" prop="ubrId">
          <a-select
            style='max-width: 370px;'
            v-model="ruleForm.ubrId"
            mode="multiple"
            placeholder="请选择"
            option-label-prop="label"
          >
            <a-select-option v-for="item in optionList" :key="item.id" :value="item.id" :label="item.name">
              <span role="img" :aria-label="item.name">{{ item.name }}</span>
            </a-select-option>
          </a-select>
          <span> *支持多选，提交即更新票型</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSourceItemClick(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'UbrTicketPro',
  components: { SelectedProductDialog },
  data() {
    return {
      submitLoading: false,
      queryParams: {},
      currentLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        offsetCol: { offset: 4 }
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      loadPromise: params => this.getListPromise(params),
      loadProductPromise: params => this.getProductListPromise(params),
      visible: false,
      showSelectedDialog: false,
      ruleForm: {
        ubrId: undefined,//环球影城门票id  多个逗号拼接
        proId: undefined,
        id: undefined
      },
      rules: {
        id: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        proId: [
          { required: true, message: '请选择商品ID', trigger: 'blur' }
        ],
        ubrId: [
          { required: true, message: '请选择供应商门票名称', trigger: 'change' }
        ]
      },
      supplierList: [],
      optionList: [],
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 1
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'UbrTicketPro', title: '商品绑定' },
      { name: 'UbrTicketOrder', title: '订单直连' },
      { name: 'UbrAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('ubr/getUBRBindProducts', params)
    },
    //获取商品库
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    //选择商品
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.getLogUtils().logWithTag('onSourceItemClick', item)
      this.ruleForm.proId = item.proId
      this.showSelectedDialog = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 绑定商品
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      params.ubrId = params.ubrId && params.ubrId.length > 0 ? params.ubrId.join(',') : ''
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getServerApiService().post('/ubr/bindUBRProduct', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.$message.success('商品绑定成功,请稍后刷新页面查看')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    unbind(item) {
      let params = {
        optionId: item.optionId
      }
      this.getHttpServices().getProService().post('ubr/removeUBRBindProduct', params)
        .then(res => {
          this.$message.success('删除绑定成功')
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(id) {
      this.getHttpServices().getServerApiService().post('ubr/getUBRProducts', {
        id: id
      }).then(res => {
        this.getLogUtils().logWithTag('handleChange', res)
        if (res && res.length > 0) {
          this.optionList = res
        } else {
          this.optionList = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getSupplierList() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId,
        type: 1,
        limitDto: {
          pageNum: 1,
          pageSize: 1000
        }
      }
      this.getHttpServices().getServerApiService().post('ubr/getUBRAccountList', params).then(res => {
        this.getLogUtils().logWithTag('getSupplierList', res)
        if (res && res.data && res.data.length > 0) {
          this.supplierList = res.data
        } else {
          this.supplierList = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    productCancel() {
      this.showSelectedDialog = false
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        ubrId: undefined,//环球影城门票id  多个逗号拼接
        proId: undefined,
        id: undefined
      }
      this.getSupplierList()
    },
    handleCancel() {
      this.visible = false
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'proType'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'channelName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped></style>

